import { Detail } from './Detail';

export interface SearchResult<T> extends Detail {
    totalCount: number;
    result: T[];
}
